import { render } from "./SectionBorder.vue?vue&type=template&id=2180c5c2"
const script = {}
script.render = render

export default script